import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonPopover } from './Popover.definition';
import { chameleonPopoverContent } from './PopoverContent/PopoverContent.definition';
function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonPopoverContent(), chameleonPopover());
}
registerCustom();
